const pgcetmbaGeneralKnowledge = [
  {
    id: 81,
    question: "Ustad Bismillah Khan is famous for ______. He was honoured with the ______ award.",
    options: ["A. Shehnai, Bharat Ratna", "B. Sitar, Bharat Ratna", "C. Bansuri, Padma Shri", "D. Sarod, Bharat Ratna"],
    answer: "A"
  },
  {
    id: 82,
    question: "In which year did the Supreme Court make a ruling regarding medical professionals' liability under the Consumer Protection Act?",
    options: ["A. 1986", "B. 1995", "C. 2019", "D. 2022"],
    answer: "B"
  },
  {
    id: 83,
    question: "In which year was the Explosives Act proposed to be replaced with the new Explosives Bill 2024?",
    options: ["A. 1892", "B. 1910", "C. 1956", "D. 1884"],
    answer: "D"
  },
  {
    id: 84,
    question: "Which among the following organisations are responsible for canalising export and import of India? I. Mineral and Metal Trading Corporation II. Exim Bank III. State Trading Corporation IV. Food Corporation of India. Select the correct answer from the code given below:",
    options: ["A. I, II, III, and IV", "B. II and IV", "C. I and III", "D. II, III and IV"],
    answer: "C"
  },
  {
    id: 85,
    question: "The Urban Swachh Bharat Mission 2.0 will be implemented over a period of 5 years with an outlay of ______.",
    options: ["A. 2.41 lakh crore", "B. 1.41 lakh crore", "C. 1.21 lakh crore", "D. 2.21 lakh crore"],
    answer: "B"
  },
  {
    id: 86,
    question: "The Mudra Yojana of the Government of India is designed to:",
    options: [
      "A. Initiate reforms in the currency management",
      "B. Provide loans to poor farmers",
      "C. Supplement the Jan Dhan Yojana",
      "D. Provide easy financial assistance to set up small businesses"
    ],
    answer: "D"
  },
  {
    id: 87,
    question: "For initial surveys of tunnels, the following activities are involved: 1. Marking portal point with concrete pillars on the ground. 2. Marking tunnel obligatory points on the topographical maps. 3. Preliminary setting of the tunnel on the topographical Survey of India maps. 4. Driving lines between the fixed obligatory points. The correct sequence of the activities is:",
    options: ["A. 3, 2, 4, 1", "B. 1, 2, 3, 4", "C. 4, 3, 1, 2", "D. 2, 4, 3, 1"],
    answer: "A"
  },
  {
    id: 88,
    question: "A device used for listening the sound of heart is:",
    options: ["A. odometer", "B. CT scanner", "C. MRI", "D. Stethoscope"],
    answer: "D"
  },
  {
    id: 89,
    question: "In which of the following states of India is the 'Ambubachi Mela' held every year?",
    options: ["A. Kerala", "B. Gujarat", "C. Sikkim", "D. Assam"],
    answer: "D"
  },
  {
    id: 90,
    question: "The story Gandatindu Jataka was written in which language?",
    options: ["A. Sanskrit", "B. Telugu", "C. Tamil", "D. Pali"],
    answer: "D"
  },
  {
    id: 91,
    question: "Where are the headquarters of the Zoological Survey of India, which conducts surveys for fauna in India?",
    options: ["A. Mumbai", "B. Ahmedabad", "C. Bangalore", "D. Kolkata"],
    answer: "D"
  },
  {
    id: 92,
    question: "In which year was the Securities and Exchange Board of India (SEBI) given statutory powers through the SEBI Act?",
    options: ["A. 1985", "B. 1990", "C. 1992", "D. 1996"],
    answer: "C"
  },
  {
    id: 93,
    question: "Climber Purnima Shrestha, who achieved the feat of climbing Mount Everest three times in a season, belongs to which country?",
    options: ["A. Nepal", "B. Srilanka", "C. India", "D. Bhutan"],
    answer: "A"
  },
  {
    id: 94,
    question: "Kaziranga National Park, famous for the one-horned rhinoceros, is located in which state?",
    options: ["A. West Bengal", "B. Assam", "C. Arunachal Pradesh", "D. Meghalaya"],
    answer: "B"
  },
  {
    id: 95,
    question: "Which individual is not included in the list of brand ambassadors for the ICC Men's T20 World Cup 2024?",
    options: ["A. Shahid Afridi", "B. Yuvraj Singh", "C. Virender Sehwag", "D. Usain Bolt"],
    answer: "C"
  },
  {
    id: 96,
    question: "From which ashram did Mahatma Gandhi begin the Dandi March (Salt March) on 12 March 1930?",
    options: ["A. Sevagram Ashram", "B. Tolstoy Farm", "C. Sabarmati Ashram", "D. Phoenix Settlement"],
    answer: "C"
  },
  {
    id: 97,
    question: "The major economic attribute for comparing countries is their:",
    options: ["A. Income", "B. Human development index", "C. Population", "D. Mortality rate"],
    answer: "A"
  },
  {
    id: 98,
    question: "Direction: Choose the appropriate articles for the given sentence: Which Article of the Indian Constitution deals with the administration of Scheduled areas and Tribal areas?",
    options: ["A. Article 214", "B. Article 240", "C. Article 244", "D. Article 248"],
    answer: "C"
  },
  {
    id: 99,
    question: "In which year the Planning Commission was established?",
    options: ["A. 1950", "B. 1951", "C. 1952", "D. 1949"],
    answer: "A"
  },
  {
    id: 100,
    question: "What was the focus of the 'Poshan Utsav' organized by the Ministry of Women and Child Development?",
    options: ["A. Education", "B. Healthcare", "C. Nutrition", "D. Environment"],
    answer: "C"
  }
];

export default pgcetmbaGeneralKnowledge;